import dayjs from "dayjs";

// Device history arrives as an ISO timestamp; show it in the viewer's local time.
export const formatDoSensorReportDateTime = (value) =>
  value ? dayjs(value).format("DD-MM-YYYY HH:mm:ss") : "--";

export const formatDoSensorDashboardDateTime = (value) =>
  value ? dayjs(value).format("DD/MM/YYYY HH:mm:ss") : "--";

export const formatDoSensorChartTime = (value) =>
  value ? dayjs(value).format("HH:mm") : "";
